import { createIntl, createIntlCache } from 'react-intl';
import translations from '~/infra/i18n/locales';
import { getLocale } from '~/utils/getLocale';
import { AppointmentFiltered } from '~/domain/usecases/appointment/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import { UnexpectedError, Forbidden, BadGateway } from '~/domain/errors';
import { AlertMessage } from '~/presentation/components/messages/AlertMessage';
import '~/infra/global/variables';

const cache = createIntlCache();

const intl = createIntl(
  {
    locale: String(getLocale()),
    messages: translations[getLocale()],
  },
  cache,
);

export class RemoteAppointmentFiltered implements AppointmentFiltered {
  private readonly url: string;

  private readonly httpClient: HttpClient<AppointmentFiltered.Model>;

  constructor(url: string, httClient: HttpClient<AppointmentFiltered.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  post = async (
    params: AppointmentFiltered.Params,
  ): Promise<AppointmentFiltered.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      method: 'post',
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
